import { CategoryConfig } from '@/types/category';
import { Newspaper } from 'lucide-react';

export const newsMeditationConfig: CategoryConfig = {
  name: 'News Meditation',
  color: 'from-slate-600 to-slate-800',
  icon: Newspaper,
  description: 'Process current events and stay zen despite the chaos - Fuck the news, stay zen as fuck',
  requiresAgeVerification: true,
  defaultPrompt: `Create a therapeutic meditation that helps process current news stress using explicit language when appropriate. 

CORE APPROACH: "Fuck the news, because we will stay zen as fuck"

Style Guidelines:
- Use therapeutic profanity to validate news frustration 
- Acknowledge the specific current events without amplifying fear
- Help transition from news overwhelm to inner peace
- Reference today/current time to show you understand this is recent
- Include media detox and grounding techniques
- Build up the user's resilience, never tear them down
- Balance raw honesty about news reality with empowering perspective

The session should help users process today's information overload while maintaining their mental well-being.`,
  
  samplePrompt: `Today's breaking news cycle is absolutely relentless - create a 10-minute "News Detox" meditation that:

1. Validates how fucking exhausting constant news updates can be
2. Guides breathing exercises to release news-induced anxiety  
3. Uses grounding techniques to return focus to what they can control
4. Includes the mantra "Fuck the news chaos, I choose my inner peace"
5. Helps them set healthy news consumption boundaries
6. Ends with empowerment about their ability to stay informed but centered

Make it raw, real, and therapeutic - helping them process current events without being consumed by them.`,

  presetMeditations: [
    {
      id: 'breaking-news-stress',
      name: 'Breaking News Stress Relief',
      text: 'Quick 5-minute reset when headlines overwhelm you'
    },
    {
      id: 'daily-news-detox',
      name: 'Daily News Detox',
      text: '15-minute session to process and release news anxiety'
    },
    {
      id: 'media-overwhelm',
      name: 'Media Overwhelm Recovery', 
      text: 'Comprehensive session for information overload relief'
    },
    {
      id: 'perspective-reset',
      name: 'News Perspective Reset',
      text: 'Reframe current events from a grounded, empowered viewpoint'
    }
  ]
};